"use strict";

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POST_DEFAULTS = exports.FETCH_BUFFER_DEFAULTS = exports.FETCH_JSON_DEFAULTS = exports.FETCHER_DEFAULTS = exports.getAllHeaders = void 0;

var cookie_1 = __importDefault(require("cookie"));

function getAllHeaders(options) {
  var headers = options.headers || {};

  if (options.cookies && Object.entries(options.cookies).length > 0) {
    headers['Cookie'] = Object.entries(options.cookies).map(function (entry) {
      return cookie_1.default.serialize(entry[0], entry[1]);
    }).reduce(function (a, b) {
      return "".concat(a, "; ").concat(b);
    });
  }

  return headers;
}

exports.getAllHeaders = getAllHeaders;
exports.FETCHER_DEFAULTS = {
  method: 'GET',
  attempts: 1,
  waitTime: '1s',
  timeout: '5m'
};
exports.FETCH_JSON_DEFAULTS = _objectSpread({}, exports.FETCHER_DEFAULTS, {
  timeout: '30s',
  waitTime: '0.5s'
});
exports.FETCH_BUFFER_DEFAULTS = _objectSpread({}, exports.FETCHER_DEFAULTS, {
  timeout: '1m'
});
exports.POST_DEFAULTS = _objectSpread({}, exports.FETCHER_DEFAULTS, {
  method: 'POST'
});